import { Role, useGetEmployeeUsingTokenQuery } from '../../api/generated';
import { SearchBar } from '../main/SearchBar';
import AddEmployeeButton from './AddEmployeeButton';
import EmployeeTypeButton from './EmployeeTypeButton';
import TransferAccountButton from './TransferAccountButton';

export default function Search() {
    const { data: loggedInUser } = useGetEmployeeUsingTokenQuery();
    return (
        <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-5">
            <div>
                <SearchBar placeholder="Search by Employee Name or Email" />
            </div>
            <div className="pt-2 grid grid-cols-3 lg:gap-32">
                <EmployeeTypeButton />
                {loggedInUser?.getEmployeeUsingToken?.role === Role.Admin ? (
                    <AddEmployeeButton />
                ) : null}

            </div>
            <div>
                <TransferAccountButton />
            </div>
        </div>
    );
}
